'use strict';

angular.module('shiftTraderApp')
    .directive('saFooterDayInformationArea', function () {
      return {
        templateUrl: 'views/directives/saFooterDayInformationArea.html',
        restrict: 'A',
        scope: {
          org: '=',
          deptData: '=saFooterDayInformationArea',
          dtTwix: '='
        },
        link: function (scope, elem, attrs) {


        }
      }
    });
